/**
 * Fetch data from API and return the response as JSON
 *
 * @param {string} endPoint - The endpoint of the API
 * @param {object} [body=null] - The body of the request
 * @param {string} [method='GET'] - The method of the request
 * @return {Promise<Object>} The response data as JSON
 */
export const getApiData = async (endPoint, body = null, method = 'GET') => {
	const baseURL = (<any>window).ssb.cdn_url;
	const URL = baseURL + endPoint;

	const response = await fetch(URL, {
		method: method,
		body: body,
		headers: {
			'Content-Type': 'application/json',
		},
	});

	return await response.json();
};

/**
 * Tries to fetch a given URL. If it fails, it will silently ignore the error.
 *
 * @param {string} url - The URL to fetch
 */
export const tryCatchAndFetchUrl = (url: string): void => {
	try {
		fetch(url);
	} catch (error) {
		console.error('Error: ', error);
	}
};

export const writeLogForShareableLink = (message, response, base64Data, errorInfo?: any) => {
	const hostname = window.location.hostname;
	const isLocalEnvironment =
		hostname === '' ||
		hostname === 'localhost' ||
		hostname === '127.0.0.1' ||
		hostname === '::1' ||
		hostname.endsWith('.local');

	if (isLocalEnvironment) return;
	const windowGlobal = <any>window;
	const url = windowGlobal.ssb.ajax_url;
	const type = 'POST';
	const action = 'write_log_for_share_link';
	const dataType = 'json';
	const modelUrl = window.location.href;
	response = response ? JSON.stringify(response) : '';
	const errorInfoStr = errorInfo ? JSON.stringify(errorInfo) : '';
	const data = {
		action,
		message,
		response,
		base64Data,
		modelUrl,
		errorInfo: errorInfoStr,
		hostName: hostname,
	};
	jQuery.ajax({ url, type, dataType, data });
};

//TO DO: need remove after debug
export const writeLogForGetLocationSettings = (message, response, dataLog) => {
	const hostname = window.location.hostname;
	const isLocalEnvironment =
		hostname === '' ||
		hostname === 'localhost' ||
		hostname === '127.0.0.1' ||
		hostname === '::1' ||
		hostname.endsWith('.local');

	if (isLocalEnvironment) return;

	const windowGlobal = <any>window;
	const url = windowGlobal.ssb.ajax_url;
	const type = 'POST';
	const action = 'write_log_get_location_settings';
	const dataType = 'json';
	const modelUrl = window.location.href;
	response = response ? JSON.stringify(response) : '';
	const data = { action, message, response, dataLog, modelUrl, hostName: hostname };
	jQuery.ajax({ url, type, dataType, data });
};
